import { FormikProps } from "formik";
import ATMSelectSearchable from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import useModules from "src/hooks/useModules";
import { CourseFormValues } from "src/models/Course.model";
import { handleValidNumber } from "src/utils/validations/numberInput";

type Props = {
  formikProps: FormikProps<CourseFormValues>;
};

const CourseDetails = ({ formikProps }: Props) => {
  const { values, setFieldValue, handleBlur } = formikProps;
  const { modules, isDataLoading } = useModules();

  const moduleOptions = modules?.map((module) => {
    return {
      label: module?.moduleName,
      value: module?._id,
    };
  });
  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium"> Course </div>

      </div>
      <div className="flex flex-col gap-4">
        {/* Course Name */}
        <div className="">
          <ATMTextField
            name="courseName"
            value={values.courseName}
            onChange={(e) => setFieldValue("courseName", e.target.value)}
            label="Course Name"
            placeholder="Enter Course Name"
            onBlur={handleBlur}
          />
        </div>
        {/* Description */}
        <div className="">
          <ATMTextArea
            name="courseDescription"
            value={values.courseDescription}
            onChange={(value) => setFieldValue("courseDescription", value)}
            label="Description"
            placeholder="Enter Description"
            onBlur={handleBlur}
          />
        </div>

        {/* Modules */}
        <div className="">
          <ATMSelectSearchable
            name="moduleId"
            value={values.moduleId}
            isLoading={isDataLoading}
            onChange={(newValue) => {
              setFieldValue("moduleId", newValue);
            }}
            label="Modules"
            placeholder="Select Modules"
            options={moduleOptions}
          />
        </div>

        {/* Classroom Fees */}
        <div className="">
          <ATMTextField
            name="classroomFees"
            value={values.classroomFees}
            onChange={(e) =>
              handleValidNumber(e) &&
              setFieldValue("classroomFees", e.target.value)
            }
            label="Classroom Fees"
            placeholder="Enter Classroom Fees"
            onBlur={handleBlur}
          />
        </div>
        {/* Online Fees */}
        <div className="">
          <ATMTextField
            name="onlineFees"
            value={values.onlineFees}
            onChange={(e) =>
              handleValidNumber(e) &&
              setFieldValue("onlineFees", e.target.value)
            }
            label="Online Fees"
            placeholder="Enter Online Fees"
            onBlur={handleBlur}
          />
        </div>
      </div>
      {/* <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div> */}
    </div>
  );
};

export default CourseDetails;
